module.exports = __webpack_public_path__ + "img/福建省源头治超监管平台.27923f88.png";